module.exports = __webpack_public_path__ + "static/media/toc-brand-guidelines-1.f8f4c1c4.jpg";